<div class="toast-stack" *ngIf="(jobs$ | async)?.length">
  <div
    *ngFor="let job of jobs$ | async; trackBy: trackById"
    class="toast-card"
    [class.toast-card--complete]="job.status === 'complete'"
    [class.toast-card--failed]="job.status === 'failed'">
    <span class="toast-icon">
      <span *ngIf="isActive(job)" class="spinner"></span>
      <span *ngIf="job.status === 'complete'">✓</span>
      <span *ngIf="job.status === 'failed'">✗</span>
    </span>
    <span class="toast-message">{{ job.message }}</span>
    <button class="toast-dismiss" (click)="dismiss(job.id)" title="Dismiss">×</button>
  </div>
</div>
